import {useContext} from 'react';

import CookiesContext from './cookiesContext';

/**
 * Hook to get cookie by name if "name" arg is passed, all cookies otherwise
 * @param {string} name - cookie name
 * @return {Array} cookies data
 */
export function useCookies(name?: string) {
    const manager = useContext(CookiesContext);

    if (!manager) {
        throw new Error('Missing <CookiesProvider>');
    }

    if (name) {
        return [manager.get(name)];
    }

    return [manager.getAll()];
}
